<template>
  <div :style="{ position: 'relative' }">
    <spring-spinner
      v-if="isLoading"
      class="loading"
      :animation-duration="1000"
      :size="40"
      :color="$themes.primary"
    />
    <va-card v-else>
      <p class="display-2">
        {{ category.name }}
        <img :src="category.icon" alt class="icon" />
      </p>

      <div class="row">
        <div
          v-for="coverPhoto in category.cover_photos"
          :key="coverPhoto.id"
          class="flex xs6 md3 xl2 cover-photo__item"
        >
          <va-button
            @click.once="removePhotoCover(coverPhoto.id)"
            icon="fa fa-remove"
            class="cover-photo__delete"
            color="danger"
            :disabled="isLoadingPhoto"
          >{{ $t('categories.photoCoverDelete') }}</va-button>
          <img class="cover-photo__img" :src="coverPhoto.file" alt />
        </div>
        <div class="flex xs6 md3 xl2">
          <upload-photo :is-loading="isLoadingPhoto" @input="inputImage" />
        </div>
      </div>
    </va-card>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { SpringSpinner } from 'epic-spinners'
import UploadPhoto from './components/UploadPhoto.vue'
export default {
  data() {
    return {
      isLoadingPhoto: false,
      isLoading: false,
    }
  },
  props: {
    currentId: {
      type: Number,
      default: function() { return +this.$route?.params?.id },
    },
  },
  components: { SpringSpinner, UploadPhoto },
  computed: {
    ...mapState({
      category(state) {
        return state.Categories.items.find(el => el.id === this.currentId)
      },
    }),
    parentId() {
      if (this.category?.parent !== null) {
        return this.category?.parent?.id
      }
      return null
    },
  },
  methods: {
    ...mapActions('Categories', ['getItem', 'coverSetPhoto', 'coverDelPhoto']),
    ...mapMutations('Categories', ['SET_ITEM']),
    async inputImage(file) {
      this.isLoadingPhoto = true
      const payload = new FormData()
      payload.append('file', file)
      payload.append('category', this.category.id)
      await this.coverSetPhoto(payload)
      this.isLoadingPhoto = false
    },
    async removePhotoCover(id) {
      this.isLoadingPhoto = true
      await this.coverDelPhoto(id)
      this.isLoadingPhoto = false
    },
  },
  async created() {
    this.isLoading = true
    await this.getItem(this.currentId)
    this.isLoading = false
  },
}

</script>
<style lang="scss" scoped>
.icon {
  width: 30px;
  height: 30px;
  object-fit: cover;
  margin-left: 15px;
}

.category-name {
  display: flex;
  align-items: center;
}

.loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

p {
  color: var(--va-textColor);
}

.cover-photo {
  &__delete {
    position: absolute;
    z-index: 99;
    top: 20px;
    right: 20px;
  }

  &__item {
    position: relative;
    overflow: hidden;
  }

  &__img {
    max-width: 100%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: 500ms;

    &:hover {
      transform: scale(1.05);
    }
  }

  &__loading {
    position: absolute;
    opacity: 0.8;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: var(--va-background);
    left: 0;
    top: 0;
  }

  &__upload {
    height: 100%;
    min-height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: dashed 2px var(--va-textColor);

    input {
      cursor: pointer;
      height: 100%;
      position: absolute;
      width: 100%;
      opacity: 0;
    }
  }
}
</style>
